<template>
    <div>
        <div class="me-header"></div>
        <div class="text-center" style="margin-top:-30px;">
            <img :src="avatar.indexOf('http') >= 0 ? avatar : $config.assetsUrl + avatar" class="avatar"/>
        </div>
        <div class="text-center flex flex-jc margin-top-20" v-if="info">
            <span class="flex flex-ai level-tag" :class="{red:info.vip_state === 1}">
                <van-icon name="gem-o" class="red margin-right-5" v-if="info.vip_state === 1"/>
                <van-icon name="medal-o" class="margin-right-5" v-else/>
                {{info.vip_state === 1 ? 'VIP会员' : '普通会员'}}
            </span>
        </div>
        <van-cell-group class="margin-top-70" v-if="info">
            <van-cell title="招标网账号" :value="info.mobile" icon="contact"/>
            <van-cell title="公司" :value="info.company" icon="hotel-o"/>
            <van-cell title="职位" :value="info.job" icon="manager-o" v-if="info.job"/>
            <van-cell title="Email" :value="info.email" icon="envelop-o" v-if="info.email"/>
            <van-cell title="电话" :value="info.mobile" icon="phone-o"/>
            <van-cell title="我的收藏" is-link icon="star-o" @click="$router.push({path:'/me/favorite'})"/>
        </van-cell-group>
        <van-cell-group class="margin-top-40">
            <van-cell title="退出登录" is-link icon="revoke" @click="logout"/>
        </van-cell-group>
    </div>
</template>

<script>
export default {
    name: "index",
    data(){
        return{
            info:null,
            avatar:''
        }
    },
    created() {
        this.$emit('bgColor','#fff');

        this.avatar = this.$user.getAvatar();
    },
    mounted() {
        this.getMe();
    },
    methods:{
        logout(){
            this.$user.logout();
            this.$notify({ type: 'success', message: '已退出登录' });

            this.$router.replace({path:'/login',query:{...this.$route.query}});
        },
        getMe(){
            let _this = this;

            this.$http.post({
                url:'AuthUser/getProfile',
                data:null,
                success(res){
                    console.log(res);
                    _this.info = res;
                }
            })
        }
    }
}
</script>
